<template>
  <div>
    <div v-if="justView || addQuestionTemplate === 'default'" class="row">
      <div
        class="col-xl-8 mt-auto mb-auto text"
        :style="{
          color: textColor || '#000000',
        }"
      >
        <span :class="`${this.$route.fullPath.includes('treatments') ? 'text-addquestion' : ''}`"> {{ questionText }} </span>
      </div>
      <div
        v-if="justView"
        class="col-xl-4 text-center mt-auto mb-auto"
        style="display: flex; justify-content: center"
      >
        <div v-if="selected === 1">
          <label class="icon" style="cursor: auto">
            <i class="fas fa-thumbs-down icon-view"></i>
            <i class="fas fa-thumbs-up icon-view" style="color: green"></i>
          </label>
        </div>
        <div v-else-if="selected === 0">
          <label class="icon" style="cursor: auto">
            <i class="fas fa-thumbs-down icon-view" style="color: red"></i>
            <i class="fas fa-thumbs-up icon-view"></i>
          </label>
        </div>
        <div v-else>
          <label class="icon" style="cursor: auto">
            <i class="fas fa-thumbs-down icon-view"></i>
            <i class="fas fa-thumbs-up icon-view"></i>
          </label>
        </div>

        <applicable
          v-if="reviewAnswer === -1"
          :itemId="index"
          :justView="justView"
        />
      </div>
      <div
        v-else
        class="col-xl-4 text-center mt-auto mb-auto"
        style="display: flex; justify-content: center"
      >
        <label class="icon">
          <input
            type="radio"
            :id="`like-dislike`"
            :name="`like-dislike-${index}`"
            value="0"
            :checked="selected === 0"
            v-model="review"
            @click="handleClick($event.target.value)"
          />
          <i class="fas fa-thumbs-down thumbs-down"></i>
        </label>
        <label class="icon">
          <input
            type="radio"
            :id="`like-dislike`"
            :name="`like-dislike-${index}`"
            value="1"
            :checked="selected === 1"
            v-model="review"
            @click="handleClick($event.target.value)"
          />
          <i class="fas fa-thumbs-up thumbs-up"></i>
        </label>

        <applicable
          v-if="applicableEnabled"
          :itemId="index"
          v-model="applicabled"
          @click.native="selectedButton = !selectedButton"
          :selectedButton="selectedButton"
          :lang="lang"
        />
      </div>
    </div>

    <div v-else>
      <div class="row">
        <div
          class="col-xl-12 mt-auto mb-auto text"
          style="display: flex; align-items: center; justify-content: center"
          :style="{
            color: textColor || '#000000',
          }"
        >
          {{ questionText }}
        </div>
        <div
          v-if="justView"
          class="col-xl-4 text-center mt-auto mb-auto"
          style="display: flex; justify-content: center"
        >
          <div v-if="selected === 1">
            <label class="icon" style="cursor: auto">
              <i class="fas fa-thumbs-down icon-view"></i>
              <i class="fas fa-thumbs-up icon-view" style="color: green"></i>
            </label>
          </div>
          <div v-else-if="selected === 0">
            <label class="icon" style="cursor: auto">
              <i class="fas fa-thumbs-down icon-view" style="color: red"></i>
              <i class="fas fa-thumbs-up icon-view"></i>
            </label>
          </div>
          <div v-else>
            <label class="icon" style="cursor: auto">
              <i class="fas fa-thumbs-down icon-view"></i>
              <i class="fas fa-thumbs-up icon-view"></i>
            </label>
          </div>

          <applicable
            v-if="reviewAnswer === -1"
            :itemId="index"
            :justView="justView"
          />
        </div>
        <div
          v-else
          class="col-xl-12 text-center mt-auto mb-auto"
          style="display: flex; align-items: center; justify-content: center"
        >
          <label class="icon-big">
            <input
              type="radio"
              :id="`like-dislike`"
              :name="`like-dislike-${index}`"
              value="0"
              :checked="selected === 0"
              v-model="review"
              @click="handleClick($event.target.value)" />
            <font-awesome-icon
              :icon="['fas', 'thumbs-down']"
              class="thumbs-down"
          /></label>
          <label class="icon-big">
            <input
              type="radio"
              :id="`like-dislike`"
              :name="`like-dislike-${index}`"
              value="1"
              :checked="selected === 1"
              v-model="review"
              @click="handleClick($event.target.value)" />
            <font-awesome-icon :icon="['fas', 'thumbs-up']" class="thumbs-up"
          /></label>

          <applicable
            v-if="applicableEnabled"
            :itemId="index"
            v-model="applicabled"
            @click.native="selectedButton = !selectedButton"
            :selectedButton="selectedButton"
            :lang="lang"
          />
        </div>
      </div>
    </div>

    <comment-area
      :clickButton="expandComment"
      :template="addQuestionTemplate"
      v-if="commentEnabled && !justView"
      v-model="comment"
    />

    <p
      v-if="hasComment && justView"
      class="comment-area"
      :style="{
        color: textColor || '#000000',
      }"
    >
      Comentário: {{ hasComment }}
    </p>

    <hr />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import commentArea from '../comment-area';
import applicable from '../applicable';

export default {
  components: {
    commentArea,
    applicable,
  },

  props: {
    textColor: { type: String, required: false },
    questionText: { type: String, required: true },
    index: { type: Number, required: true },
    justView: { type: Boolean, default: false },
    selected: { type: Number },
    myItems: { required: false },
    commentEnabled: { type: Boolean, default: false },
    applicableEnabled: { type: Boolean, default: false },
    hasComment: { type: String, default: null },
    reviewAnswer: { type: Number, required: true, default: -99 },
    addQuestionTemplate: { type: String, required: true, default: 'default' },
    idQuestion: { type: String, required: true },
    itemId: { type: String, required: true },
    lang: { type: String, default: 'br' }
  },
  data: () => ({
    position: null,
    review: null,
    comment: null,
    applicabled: null,
    selectedButton: false,
    expandComment: false,
  }),
  watch: {
    comment: function watchComment() {
      this.update();
    },
    applicabled: function watchApplicated(value) {
      this.$emit('input', {
        review: Number(value),
        comment: this.comment,
        position: this.itemId,
        _id: this.idQuestion,
      });
    },
    selectedButton: function watchSelectedButton(value) {
      if (value) {
        this.selectedButton = true;
        this.review = null;

        this.$emit('input', {
          review: -1,
          comment: this.comment,
          position: this.itemId,
          _id: this.idQuestion,
        });
      }
    },
  },
  computed: {
    ...mapState('research', ['likeReview']),
  },
  methods: {
    update() {
      this.$emit('input', {
        review: Number(this.review),
        comment: this.comment,
        position: this.itemId,
        _id: this.idQuestion,
      });
    },
    handleClick(value) {
      if (this.review === value) {
        this.review = null;
        this.expandComment = false;
      } else {
        this.review = Number(value);
        this.expandComment = true;
      }

      this.selectedButton = false;
      this.update();
    },
  },
  mounted() {
    this.position = this.$store.state.research.likeControl;
    this.$store.state.research.likeControl += 1;
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

@media only screen and (max-width: 1200px) {
  .text {
    text-align: center;
  }
}

.icon {
  padding: 10px 0 0 0;
  font-size: 25px;
  color: $gray;
  &:hover {
    cursor: pointer;
  }
}

.icon-big {
  padding: 10px 0 0 0;
  font-size: 40px;
  color: $gray;
  &:hover {
    cursor: pointer;
  }
}

.icon-view {
  font-size: 22px;
  margin-left: 20px;
  color: $gray;
}

.thumbs-up {
  margin-left: 15px;
  &:hover {
    color: #64b64d;
  }
}

.thumbs-down {
  &:hover {
    color: red;
  }
}

input[type='radio'] {
  display: none;
  &:checked {
    ~ .thumbs-down {
      color: red;
    }
    ~ .thumbs-up {
      color: #64b64d;
    }
  }
}

.comment-area {
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/metrics/like-dislike/index.vue